import React, { useState, useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../HoleInOne.module.scss';
import metadata from './RiskInformationComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function RiskInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RiskInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const [rawDate, setRawDate] = useState('');
    const [formattedDate, setFormattedDate] = useState('');
    

    modelVM.isValidationReq.value = true;

        const getAddressOptions = () => {
            const availableValues = submissionVM.value.baseData.policyLocations_Ext.map((actLct) => ({
                code: actLct.fixedId,
                name: actLct.address.displayName
            }));
    
            return availableValues;
        };

        const fillAddressDetails = (value, changedPath) => {
            const loc = _.find(submissionVM.value.baseData.policyLocations_Ext, (actLct) => actLct.fixedId === parseInt(value, 10));

            modelVM.addressOfLocRisk.value = loc ? loc.fixedId : null;
            handleValueChange(modelVM.addressOfLocRisk.value, changedPath)
        };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        '@dropdownSelect': {
            showRequired: true,
        },
        touStaDatAndTim: {
            required: true
        },
        touEndDatAndTim: {
            required: true
        },
        addressOfLocRisk: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        ifVal750Or250PleSpe18: {
            visible: _.get(modelVM, 'priValOfTheInsHol17.value') !== undefined
                && (_.get(modelVM, 'priValOfTheInsHol17.value').code === 'LesTha2500' ||
                    _.get(modelVM, 'priValOfTheInsHol17.value').code === '75000Plus')
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            // handleDateDisplayChange
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

RiskInformationComponent.propTypes = wizardProps;
export default withRouter(RiskInformationComponent);